export const baseTheme = {
  empresaId: null,
  Logo: null,

  auth: {
    login: 'cliente.woba',
    password: '123456a',
    //password: 'Hom@2025',
  },

  labels: {
    formTitle: 'Abertura de Chamado',
    formSubtitle: 'Preencha esse formulário para abrir um chamado e relatar sua solicitação.',
    nome: 'Nome*',
    area: 'Qual o Ambiente?*',
    solicitationType: 'Qual o tipo de solicitação?*',
    details: 'Conte mais detalhes*',
    email: 'Seu e-mail (opcional)',
    fotos: 'Fotos',
    submit: 'Enviar',
    successTitle: 'Seu chamado foi aberto com sucesso',
    successBody: 'Em breve será atendido.',
    successBtn: 'Entendi',
  },

  fields: {
    nome: true,
    area: true,
    solicitationType: true,
    details: true,
    email: true,
    fotos: true,
  },

  colors: {
    pageBg: '#f5f3f1',
    primary: '#f9e10d',
    primaryText: '#000000',
    primaryBorder: '#000000',
    textTitle: '#000000',
    textBody: '#444444',
    textMuted: '#808080',
    textLabel: '#1e1e1e',
    textError: '#c25446',
    inputBorder: '#e7e7e7',
    inputBorderError: '#ff0000',
    dropdownBg: '#ffffff',
  },

  typography: {
    titleFont: 'Blinker',
    titleWeight: 700,
    titleSize: '24px',
    bodyFont: 'Roboto',
    labelWeight: 700,
    labelSize: '14px',
  },

  shape: {
    buttonRadius: '4px',
    buttonWidth: '329px',
    buttonHeight: '40px',
    inputHeight: '32px',
  },
};
